var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","width":"167px","dark":"","outlined":""},on:{"click":_vm.onExport}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-file-excel-outline")]),_vm._v("Xuất Excel\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }